/** `patients.id` for /practices/:practiceId/patients/:patientId */
export function resolvePatientRecordId(patient) {
  if (!patient) return null;
  const pid = patient.patient_table_id ?? patient.id;
  if (pid == null || pid === '') return null;
  return pid;
}

/** Practice id for patient detail route (row data or active lookup practice). */
export function resolvePatientPracticeId(patient, fallbackPracticeId) {
  const fromRow = patient?.practice_id ?? patient?.practiceId;
  if (fromRow != null && String(fromRow).trim() !== '') {
    return String(fromRow).trim();
  }
  const fb = fallbackPracticeId != null ? String(fallbackPracticeId).trim() : '';
  if (fb && fb !== 'all') return fb;
  return null;
}

export function buildPatientDetailsPath(practiceId, patientId) {
  if (!practiceId || patientId == null) return null;
  return `/practices/${practiceId}/patients/${patientId}`;
}
